<div class="ticket-type">
  <p class="type">
    <i class="fa fa-ticket ticketIcon" aria-hidden="true"></i>
    {{ title }}
  </p>
  <button
    type="button"
    class="info"
    (click)="handleInfoClick()"
    aria-label="info"
  >
    <i class="fa fa-info" aria-hidden="true"></i>
  </button>
  <p class="text">{{ translatedSubtitle }}</p>
</div>
